import type { ApiResponse } from '@bower/shared';
import type { HttpClient } from './http-client.types';

export function transcribeAudio(http: HttpClient, formData: FormData) {
  return http.request(
    {
      method: 'POST',
      url: '/transcribe',
      data: formData,
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 600000,
    },
    0,
  );
}

export function uploadInlineImage(
  http: HttpClient,
  file: File,
  noteId: string,
): Promise<ApiResponse<{ url: string; filename: string; size: number; mimeType: string }>> {
  const formData = new FormData();
  formData.append('image', file);
  formData.append('noteId', noteId);
  return http.request<{ url: string; filename: string; size: number; mimeType: string }>({
    method: 'POST',
    url: '/upload/inline-image',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}
